window.OSP_MANUAL_DATA = {
  "manual": {
    "title": "DS2 Door Sensor Setup, Installation and Troubleshooting Manual",
    "product_family": "DS2 Door Sensor",
    "manual_version": "V26.1",
    "primary_app": "TTLock",
    "install_time_estimate": "15–25 minutes",
    "app_links": {
      "android_google_play": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
      "ios_app_store": "https://apps.apple.com/us/app/ttlock/id1033046018"
    },
    "compatible_apps": {
      "TTLock (recommended)": {
        "android": "https://play.google.com/store/apps/details?id=com.tongtongsuo.app",
        "ios": "https://apps.apple.com/us/app/ttlock/id1033046018"
      }
    },
    "critical_warnings": [
      "The DS2 pairs through a lock's settings in the TTLock app — add your TTLock smart lock to the app first.",
      "Pair the sensor in the app BEFORE you stick it to the door.",
      "Keep the gap between the two parts within 22 mm — beyond that the sensor cannot detect the door.",
      "Press the reset button for 2 seconds to pair. Holding it for 10 seconds factory resets the sensor.",
      "Clean the surface before applying the adhesive, and press both parts on tightly."
    ],
    "hero_title": "DS2 Door Sensor",
    "lead": "Pair your DS2 door sensor with your lock in TTLock, install it on the door and frame, understand the LED signals, replace the battery and troubleshoot setup.",
    "checklist": [
      "Add the lock to TTLock before pairing the sensor.",
      "Pair the sensor before mounting it.",
      "Keep the sensor and magnet aligned, with a gap no greater than 22 mm."
    ],
    "quick_specs": {
      "App": "TTLock",
      "Battery": "CR2032 lithium coin cell",
      "Maximum sensing gap": "22 mm (7/8 in)",
      "Pairing / reset": "2-second press / 10-second press"
    },
    "search_placeholder": "Describe the problem — e.g. won't add, flashes three times, fell off, factory reset",
    "search_suggestions": [
      "pairing",
      "LED",
      "22 mm",
      "battery",
      "reset"
    ]
  },
  "guides": [
    {
      "handle": "ds2-led-indicators",
      "title": "Understand the LED indicators",
      "category": "Preparation",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "The LED on the front of the sensor tells you exactly what it is doing. Learn the four flash patterns before you start — they make pairing and battery checks much easier.",
      "images": [
        {
          "src": "us-manual-ds2-led-indicators-1.webp",
          "alt": "DS2 LED indicator guide — the light and reset key positions, with the meaning of each flash pattern"
        }
      ],
      "steps": [
        "Find the LED on the front face of the sensor — the reset key sits below it, as shown in the diagram.",
        "Pairing: the LED flashes rapidly.",
        "Door opened or closed: the LED flashes once.",
        "Low battery: the LED flashes three times when the door is opened or closed.",
        "Factory reset: the LED stays on for 1 second."
      ],
      "expected_result": "You can read the LED at a glance — one flash per open or close is normal; three flashes means the battery needs replacing soon.",
      "common_mistakes": [
        "Mistaking the low-battery signal (three flashes on open/close) for normal operation (one flash).",
        "Thinking the rapid flicker is a fault — it simply means the sensor is in pairing mode."
      ]
    },
    {
      "handle": "ds2-add-to-app",
      "title": "Add the door sensor to the app",
      "category": "App setup",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Pair the DS2 with your lock in the TTLock app. The sensor is added through the lock's own settings, so your lock must already be in the app.",
      "app_links": true,
      "images": [
        {
          "src": "us-manual-ds2-add-to-app-1.webp",
          "alt": "Add the door sensor in the TTLock app — select the lock, tap Settings then Door sensor, tap Add door sensor and press the reset button for 2 seconds"
        },
        {
          "src": "us-manual-ds2-add-to-app-2.webp",
          "alt": "Tap the + next to the DS2 in the Nearby devices list, then wait for the Successfully screen"
        }
      ],
      "notes": [
        "The DS2 pairs through a lock's settings, so your Blusafe TTLock lock must already be added to the app before you start."
      ],
      "steps": [
        "Download the TTLock app and log in.",
        "Open the app and select the lock you want to add the door sensor to.",
        "Tap \"Settings\", then \"Door sensor\".",
        "Tap \"Add door sensor\", then press the reset button on the door sensor for 2 seconds.",
        "When the LED starts flickering rapidly, tap \"Next\".",
        "Tap the \"+\" next to the sensor in the device list and finish the adding process."
      ],
      "expected_result": "The app shows the sensor was added successfully and it appears under the lock's Door sensor settings.",
      "tips": [
        "If the sensor cannot be added, repeat the process two or three times, or factory reset the sensor and try again."
      ],
      "common_mistakes": [
        "Holding the reset button too long — 10 seconds factory resets the sensor; pairing only needs 2 seconds.",
        "Tapping \"Next\" before the LED has started flickering.",
        "Looking for the sensor on the app home screen — it is added through the lock's Settings, not \"Add Device\"."
      ]
    },
    {
      "handle": "ds2-install",
      "title": "Install the door sensor",
      "category": "Installation",
      "estimated_time": "10 minutes",
      "difficulty": "Easy",
      "summary": "Stick the sensor body and the magnet across the door and frame with the supplied adhesive, keeping the two parts within 22 mm of each other.",
      "images": [
        {
          "src": "us-manual-ds2-install-1.webp",
          "alt": "Install the DS2 — choose the door opening direction, peel the adhesive backing, then align both parts and stick them on with a gap of no more than 22 mm"
        }
      ],
      "warnings": [
        "The maximum sensing distance between the two parts is 22 mm. Leave a bigger gap and the sensor will not detect the door opening or closing."
      ],
      "steps": [
        "Decide which way your door opens — to the left or to the right — and use the diagram to pick which side each part sits.",
        "Tear the cover off the adhesive pads on the door sensor.",
        "Clean the surfaces where the sensor is to be installed.",
        "Align the two parts with each other and glue them tightly onto the door and frame."
      ],
      "expected_result": "Both parts are stuck firmly and aligned, and the LED flashes once every time the door opens or closes.",
      "common_mistakes": [
        "Fixing the two parts more than 22 mm apart.",
        "Sticking the adhesive to a dusty or dirty surface, so the sensor works loose later.",
        "Sticking the sensor down before pairing it in the app — pair first, then mount."
      ]
    },
    {
      "handle": "ds2-replace-battery",
      "title": "Replace the battery",
      "category": "Maintenance",
      "estimated_time": "5 minutes",
      "difficulty": "Easy",
      "summary": "Swap the CR2032 coin cell when the LED starts flashing three times on every open or close.",
      "images": [
        {
          "src": "us-manual-ds2-replace-battery-1.webp",
          "alt": "Replace the battery — remove the shell, pull out the used CR2032 coin cell and fit a new one, then reinstall the shell"
        }
      ],
      "notes": [
        "Battery type: CR2032 lithium coin cell."
      ],
      "steps": [
        "Remove the shell as shown in the diagram.",
        "Pull out the used battery and replace it with a new CR2032 lithium coin cell.",
        "Reinstall the shell."
      ],
      "expected_result": "The LED goes back to a single flash on open and close — the three-flash low-battery signal stops.",
      "common_mistakes": [
        "Ignoring the three-flash low-battery signal until the sensor stops reporting.",
        "Prising the shell open with a sharp tool — it opens by hand as shown in the diagram."
      ]
    },
    {
      "handle": "ds2-factory-reset",
      "title": "Factory reset the door sensor",
      "category": "Maintenance",
      "estimated_time": "2 minutes",
      "difficulty": "Easy",
      "summary": "Return the sensor to its default settings — useful when it will not pair, or when you are moving it to a different lock.",
      "images": [
        {
          "src": "us-manual-ds2-factory-reset-1.webp",
          "alt": "Reset to default settings — press the reset button on the door sensor for 10 seconds until the light stays on for 1 second"
        }
      ],
      "warnings": [
        "A factory reset returns the sensor to default settings — you will need to add it to the app again afterwards."
      ],
      "steps": [
        "Press and hold the reset button on the door sensor for 10 seconds.",
        "Watch the LED — when the light stays on for 1 second, the sensor has reset to default settings.",
        "Add the sensor to your lock again in the TTLock app."
      ],
      "expected_result": "The sensor is back to its default settings and ready to be paired as new.",
      "common_mistakes": [
        "Releasing the button too early — pairing uses a 2-second press; a factory reset needs the full 10 seconds."
      ]
    }
  ],
  "troubleshooting": [
    {
      "handle": "ds2-wont-add",
      "title": "Door sensor won't add to the app",
      "category": "App setup",
      "priority": "high",
      "explanation": "Pairing is time-sensitive: the app must be on the Add door sensor screen while the sensor's LED is flickering rapidly. If either side times out, the add fails — the manual's own advice is to simply repeat the process or reset the sensor and try again.",
      "symptoms": [
        "The sensor never appears in the device list after tapping \"Add door sensor\".",
        "The adding process starts but never finishes.",
        "The LED stops flickering before the app finds the sensor."
      ],
      "quick_checks": [
        "You are using the TTLock app and your lock is already added to it.",
        "You are in the lock's \"Settings\" → \"Door sensor\" → \"Add door sensor\" screen.",
        "You pressed the reset button for 2 seconds and the LED is flickering rapidly before tapping \"Next\".",
        "Bluetooth is on and your phone is close to the sensor.",
        "The battery is not low (three flashes on open/close means low battery)."
      ],
      "likely_causes": [
        "The LED was not in pairing mode (rapid flicker) when the app searched.",
        "The reset button was held too long — a 10-second press factory resets instead of pairing.",
        "The pairing attempt simply timed out — the manual advises repeating it two or three times.",
        "A flat or nearly flat CR2032 battery."
      ],
      "fix_steps": [
        "Press the reset button for 2 seconds and wait for the rapid flicker, then tap \"Next\" in the app.",
        "Tap the \"+\" next to the sensor as soon as it appears in the list.",
        "If it fails, repeat the whole process two or three times.",
        "Still failing? Factory reset the sensor (hold the reset button for 10 seconds until the light stays on for 1 second) and try again.",
        "If nothing changes, fit a fresh CR2032 battery and retry."
      ],
      "related_guides": [
        "ds2-add-to-app",
        "ds2-factory-reset",
        "ds2-replace-battery"
      ],
      "support_evidence": [
        "A short video of the LED while you press the reset button",
        "A screenshot of the lock's Door sensor page in the app",
        "Phone model and OS version"
      ],
      "app_links": false
    },
    {
      "handle": "ds2-wrong-app",
      "title": "Wrong app installed — the DS2 needs TTLock",
      "category": "App setup",
      "priority": "high",
      "explanation": "The DS2 is a TTLock-ecosystem accessory. It is added through a lock's settings inside the TTLock app — other smart-home apps will not find it.",
      "symptoms": [
        "Your app has no \"Door sensor\" option anywhere.",
        "The app cannot discover the sensor at all.",
        "You are using Tuya, Smart Life or another smart-home app."
      ],
      "quick_checks": [
        "Confirm the app on your phone is TTLock.",
        "Confirm your Blusafe TTLock lock is added to the same TTLock account."
      ],
      "likely_causes": [
        "A different smart-home app was installed instead of TTLock.",
        "The lock was never added to the TTLock app, so the Door sensor menu is unreachable."
      ],
      "fix_steps": [
        "Install the TTLock app from Google Play or the App Store using the buttons above.",
        "Sign in and add your lock to the app first.",
        "Select the lock, tap \"Settings\", then \"Door sensor\", and add the DS2 from there."
      ],
      "related_guides": [
        "ds2-add-to-app"
      ],
      "support_evidence": [
        "A screenshot showing which app you used",
        "A screenshot of your app device list"
      ],
      "app_links": true
    },
    {
      "handle": "ds2-no-door-sensor-menu",
      "title": "Can't find the \"Door sensor\" option in the app",
      "category": "App setup",
      "priority": "medium",
      "explanation": "The DS2 is not added from the app's home screen. The \"Door sensor\" option lives inside an individual lock's Settings page, so you must open a lock first.",
      "symptoms": [
        "There is no obvious way to add the sensor from the app home screen.",
        "You cannot see \"Door sensor\" in the app."
      ],
      "quick_checks": [
        "A TTLock lock is already added to your account.",
        "You have selected that lock, then tapped \"Settings\".",
        "You are looking for \"Door sensor\" in the Settings list."
      ],
      "likely_causes": [
        "No lock has been added to the app yet.",
        "Looking on the home screen or in \"Add Device\" instead of the lock's Settings page."
      ],
      "fix_steps": [
        "Add your Blusafe TTLock lock to the app first.",
        "Open the app and select that lock.",
        "Tap \"Settings\", then \"Door sensor\", then \"Add door sensor\" and follow the pairing steps."
      ],
      "related_guides": [
        "ds2-add-to-app"
      ],
      "support_evidence": [
        "A screenshot of the lock's Settings page",
        "Which lock model the sensor is being paired with"
      ],
      "app_links": false
    },
    {
      "handle": "ds2-not-detecting",
      "title": "Door opening or closing is not detected",
      "category": "Installation",
      "priority": "high",
      "explanation": "The DS2 senses the magnet part passing the sensor body. If the two parts sit more than 22 mm apart, or are badly misaligned, the sensor cannot register the door moving.",
      "symptoms": [
        "The LED does not flash when the door opens or closes.",
        "The app does not show door activity from the sensor.",
        "Detection is intermittent."
      ],
      "quick_checks": [
        "The gap between the two parts is within 22 mm when the door is closed.",
        "The two parts are aligned with each other as shown in the installation diagram.",
        "Both parts are stuck tightly and have not slipped.",
        "The LED flashes once when you open or close the door — three flashes means low battery.",
        "The sensor has been added to the lock in the TTLock app."
      ],
      "likely_causes": [
        "The two parts are further than 22 mm apart.",
        "The parts are misaligned or fitted on the wrong sides for the door's opening direction.",
        "One part has come loose from its surface.",
        "The battery is low or flat."
      ],
      "fix_steps": [
        "Close the door and measure the gap between the two parts — reposition them so it is within 22 mm.",
        "Check the opening-direction diagram and re-align the parts on a clean, dry surface.",
        "Press both parts on tightly so they cannot move.",
        "Open and close the door and watch for a single LED flash.",
        "If the LED flashes three times, replace the CR2032 battery."
      ],
      "related_guides": [
        "ds2-install",
        "ds2-led-indicators",
        "ds2-replace-battery"
      ],
      "support_evidence": [
        "A photo of both parts fitted, with the door closed",
        "The approximate gap between the two parts",
        "A short video of the door opening while watching the LED"
      ],
      "app_links": false
    },
    {
      "handle": "ds2-low-battery",
      "title": "LED flashes three times — battery is low",
      "category": "Battery",
      "priority": "medium",
      "explanation": "Three flashes when the door opens or closes is the DS2's low-battery signal. One flash is normal operation.",
      "symptoms": [
        "The LED flashes three times whenever the door is opened or closed."
      ],
      "quick_checks": [
        "Confirm it is three flashes on open/close, not the single normal flash.",
        "You have a spare CR2032 lithium coin cell to hand."
      ],
      "likely_causes": [
        "The CR2032 coin cell is running low."
      ],
      "fix_steps": [
        "Remove the shell from the sensor body.",
        "Pull out the used battery and fit a new CR2032 lithium coin cell.",
        "Reinstall the shell.",
        "Open and close the door — the LED should now flash once."
      ],
      "related_guides": [
        "ds2-replace-battery",
        "ds2-led-indicators"
      ],
      "support_evidence": [
        "A short video of the LED when the door opens",
        "How old the current battery is"
      ],
      "app_links": false
    },
    {
      "handle": "ds2-coming-loose",
      "title": "Sensor coming loose or falling off the door",
      "category": "Installation",
      "priority": "low",
      "explanation": "The DS2 is fixed with adhesive pads. The manual is explicit: clean the surface first and glue the parts on tightly — adhesive on a dusty or dirty surface will let go.",
      "symptoms": [
        "One or both parts have peeled away from the door or frame.",
        "A part has slipped so the two halves no longer line up."
      ],
      "quick_checks": [
        "The mounting surface was cleaned before the pads went on.",
        "The parts were pressed on firmly.",
        "The parts still sit within 22 mm of each other."
      ],
      "likely_causes": [
        "Adhesive applied to a dusty, dirty or greasy surface.",
        "The pads were not pressed on tightly."
      ],
      "fix_steps": [
        "Take the loose part off and clean the mounting surface thoroughly.",
        "Re-align the two parts using the installation diagram.",
        "Press the part on tightly and hold it for a moment.",
        "Open and close the door to confirm the LED flashes once."
      ],
      "related_guides": [
        "ds2-install"
      ],
      "support_evidence": [
        "A photo of the mounting position",
        "A photo of the adhesive pad on the loose part"
      ],
      "app_links": false
    },
    {
      "handle": "ds2-needs-reset",
      "title": "Sensor misbehaving — factory reset it",
      "category": "Maintenance",
      "priority": "medium",
      "explanation": "If the sensor refuses to pair or you are moving it to another lock, resetting it to default settings gives you a clean start. The manual recommends a reset when repeated pairing attempts fail.",
      "symptoms": [
        "Repeated pairing attempts fail even after two or three tries.",
        "The sensor was previously paired and needs to be set up again.",
        "You want to move the sensor to a different lock."
      ],
      "quick_checks": [
        "The battery is not low (three flashes on open/close).",
        "You can press and hold the reset button for a full 10 seconds."
      ],
      "likely_causes": [
        "A stale pairing from an earlier setup.",
        "A failed add that left the sensor in an in-between state."
      ],
      "fix_steps": [
        "Press and hold the reset button on the door sensor for 10 seconds.",
        "Wait for the LED to stay on for 1 second — the sensor is now reset to default settings.",
        "Add the sensor to your lock again through the TTLock app."
      ],
      "related_guides": [
        "ds2-factory-reset",
        "ds2-add-to-app"
      ],
      "support_evidence": [
        "A short video of the 10-second reset and the LED response",
        "What happens when you then try to add the sensor"
      ],
      "app_links": false
    }
  ],
  "videos": [],
  "support_templates": [
    {
      "title": "Door sensor won't add to the app",
      "subject": "DS2 Door Sensor - will not add to the TTLock app",
      "body": "Hi Blusafe team,\n\nMy DS2 Door Sensor will not add to the TTLock app. Here are my details:\n\nOrder number: \nApp used: \nLock the sensor is being added to: \nDoes the LED flicker rapidly after a 2-second press of the reset button? (yes/no): \nHow many times have you repeated the pairing process?: \nHave you factory reset the sensor (10-second press) and retried? (yes/no): \n\nI have attached:\n- A short video of the LED while I press the reset button\n- A screenshot of the lock's Door sensor page in the app\n\nThanks,\n[Your name]"
    },
    {
      "title": "Door open/close not detected",
      "subject": "DS2 Door Sensor - door opening/closing not detected",
      "body": "Hi Blusafe team,\n\nMy DS2 Door Sensor is not detecting the door opening or closing. Here are my details:\n\nOrder number: \nGap between the two parts with the door closed (mm): \nDoes the LED flash when the door opens? (once / three times / not at all): \nWas the sensor added successfully in the TTLock app? (yes/no): \nWhich way does the door open (left/right): \n\nI have attached:\n- A photo of both parts fitted, with the door closed\n- A short video of the door opening while watching the LED\n\nThanks,\n[Your name]"
    },
    {
      "title": "Battery or LED question",
      "subject": "DS2 Door Sensor - battery / LED question",
      "body": "Hi Blusafe team,\n\nI have a question about the battery or LED behaviour on my DS2 Door Sensor. Here are my details:\n\nOrder number: \nWhat the LED does (flashes once / three times / stays on / rapid flicker): \nWhen it happens (door opens / door closes / pressing the reset button): \nBattery age, and whether a fresh CR2032 has been tried: \n\nI have attached:\n- A short video of the LED behaviour\n\nThanks,\n[Your name]"
    },
    {
      "title": "Something else",
      "subject": "DS2 Door Sensor - support request",
      "body": "Hi Blusafe team,\n\nI need help with my DS2 Door Sensor. Here are my details:\n\nOrder number: \nLock the sensor is paired to: \nWhat happens, step by step: \nWhat you have already tried: \n\nI have attached:\n- A short video or photo of the issue\n- A screenshot of the lock's Door sensor page in the app\n\nThanks,\n[Your name]"
    }
  ],
  "support_evidence_default": [
    "Order number",
    "Which app you used (TTLock)",
    "Which lock the sensor is paired to",
    "Battery age, and whether a fresh CR2032 has been tried",
    "A short video of the LED while you press the reset button",
    "A screenshot of the lock's Door sensor page in the app"
  ],
  "search_index": [
    {
      "title": "DS2 Door Sensor Setup, Installation and Troubleshooting Manual",
      "type": "manual",
      "category": "Overview",
      "anchor": "osp-top",
      "summary": "LED indicators, TTLock app pairing, adhesive installation, CR2032 battery replacement, factory reset and troubleshooting.",
      "keywords": "ds2 door sensor manual ttlock led pairing install adhesive battery cr2032 factory reset troubleshooting"
    },
    {
      "title": "Understand the LED indicators",
      "type": "guide",
      "category": "Preparation",
      "anchor": "ds2-led-indicators",
      "summary": "The LED on the front of the sensor tells you exactly what it is doing — learn the four flash patterns before you start.",
      "keywords": "led light indicator flash flicker meaning status Pairing: the LED flashes rapidly. Door opened or closed: the LED flashes once. Low battery: the LED flashes three times when the door is opened or closed. Factory reset: the LED stays on for 1 second."
    },
    {
      "title": "Add the door sensor to the app",
      "type": "guide",
      "category": "App setup",
      "anchor": "ds2-add-to-app",
      "summary": "Pair the DS2 with your lock in the TTLock app — the sensor is added through the lock's own settings.",
      "keywords": "ttlock app add pair pairing bluetooth settings door sensor Download the TTLock app and log in. Open the app and select the lock you want to add the door sensor to. Tap Settings, then Door sensor. Tap Add door sensor, then press the reset button on the door sensor for 2 seconds. When the LED starts flickering rapidly, tap Next. Tap the + next to the sensor in the device list and finish the adding process."
    },
    {
      "title": "Install the door sensor",
      "type": "guide",
      "category": "Installation",
      "anchor": "ds2-install",
      "summary": "Stick the sensor body and the magnet across the door and frame, keeping the two parts within 22 mm of each other.",
      "keywords": "install mount stick adhesive glue pad 22mm gap distance align left right opening direction Decide which way your door opens — to the left or to the right. Tear the cover off the adhesive pads on the door sensor. Clean the surfaces where the sensor is to be installed. Align the two parts with each other and glue them tightly onto the door and frame."
    },
    {
      "title": "Replace the battery",
      "type": "guide",
      "category": "Maintenance",
      "anchor": "ds2-replace-battery",
      "summary": "Swap the CR2032 coin cell when the LED starts flashing three times on every open or close.",
      "keywords": "battery replace change cr2032 coin cell lithium shell low three flashes Remove the shell as shown in the diagram. Pull out the used battery and replace it with a new CR2032 lithium coin cell. Reinstall the shell."
    },
    {
      "title": "Factory reset the door sensor",
      "type": "guide",
      "category": "Maintenance",
      "anchor": "ds2-factory-reset",
      "summary": "Return the sensor to its default settings — useful when it will not pair, or when moving it to a different lock.",
      "keywords": "factory reset default settings reset button 10 seconds light on 1 second re-pair Press and hold the reset button on the door sensor for 10 seconds. When the light stays on for 1 second, the sensor has reset to default settings. Add the sensor to your lock again in the TTLock app."
    },
    {
      "title": "Door sensor won't add to the app",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "ds2-wont-add",
      "summary": "The sensor never appears in the device list after tapping Add door sensor.",
      "keywords": "won't add cannot add pair pairing fails not found timeout retry Press the reset button for 2 seconds and wait for the rapid flicker, then tap Next in the app. Tap the + next to the sensor as soon as it appears in the list. If it fails, repeat the whole process two or three times. Factory reset the sensor and try again. Fit a fresh CR2032 battery and retry."
    },
    {
      "title": "Wrong app installed — the DS2 needs TTLock",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "ds2-wrong-app",
      "summary": "Your app has no Door sensor option anywhere, or cannot discover the sensor at all.",
      "keywords": "wrong app tuya smart life which app ttlock download install Install the TTLock app from Google Play or the App Store. Sign in and add your lock to the app first. Select the lock, tap Settings, then Door sensor, and add the DS2 from there."
    },
    {
      "title": "Can't find the \"Door sensor\" option in the app",
      "type": "troubleshooting",
      "category": "App setup",
      "anchor": "ds2-no-door-sensor-menu",
      "summary": "The Door sensor option lives inside an individual lock's Settings page — you must open a lock first.",
      "keywords": "door sensor menu missing settings can't find where add device home screen no lock Add your Blusafe TTLock lock to the app first. Open the app and select that lock. Tap Settings, then Door sensor, then Add door sensor and follow the pairing steps."
    },
    {
      "title": "Door opening or closing is not detected",
      "type": "troubleshooting",
      "category": "Installation",
      "anchor": "ds2-not-detecting",
      "summary": "The LED does not flash when the door opens or closes, or the app shows no door activity.",
      "keywords": "not detecting no flash open close gap 22mm alignment misaligned intermittent Close the door and measure the gap between the two parts — reposition them so it is within 22 mm. Re-align the parts on a clean, dry surface. Press both parts on tightly. Open and close the door and watch for a single LED flash. If the LED flashes three times, replace the CR2032 battery."
    },
    {
      "title": "LED flashes three times — battery is low",
      "type": "troubleshooting",
      "category": "Battery",
      "anchor": "ds2-low-battery",
      "summary": "Three flashes when the door opens or closes is the DS2's low-battery signal.",
      "keywords": "low battery three flashes flash 3 times cr2032 coin cell replace Remove the shell from the sensor body. Pull out the used battery and fit a new CR2032 lithium coin cell. Reinstall the shell. Open and close the door — the LED should now flash once."
    },
    {
      "title": "Sensor coming loose or falling off the door",
      "type": "troubleshooting",
      "category": "Installation",
      "anchor": "ds2-coming-loose",
      "summary": "One or both parts have peeled away from the door or frame, or slipped out of line.",
      "keywords": "fell off falling loose adhesive sticky pad peel slipped restick clean surface Take the loose part off and clean the mounting surface thoroughly. Re-align the two parts using the installation diagram. Press the part on tightly. Open and close the door to confirm the LED flashes once."
    },
    {
      "title": "Sensor misbehaving — factory reset it",
      "type": "troubleshooting",
      "category": "Maintenance",
      "anchor": "ds2-needs-reset",
      "summary": "If the sensor refuses to pair or you are moving it to another lock, reset it to default settings.",
      "keywords": "reset re-pair move different lock stale pairing start again 10 seconds Press and hold the reset button on the door sensor for 10 seconds. Wait for the LED to stay on for 1 second. Add the sensor to your lock again through the TTLock app."
    }
  ],
  "support_email": "enquiries@blusafesolutions.com"
};
